import { Lightbulb, X } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { readPrefs, writePrefs } from '../../utils/taxonomy-prefs';
import { IconButton } from '../shared/icon-button';

/**
 * First-run explanation of the workflow (edit → review → publish), dismissible and
 * remembered per viewer. Shown while there are no unpublished changes yet.
 */
export function WorkflowHint() {
  const { t } = useTranslation('taxonomy-studio');
  const [hidden, setHidden] = useState(() => readPrefs().hintDismissed);
  if (hidden) return null;
  return (
    <div className="border-border bg-card flex items-start gap-3 rounded-lg border px-3 py-2.5 text-sm">
      <Lightbulb className="text-warning mt-0.5 h-4 w-4 shrink-0" aria-hidden />
      <div className="min-w-0 flex-1">
        <p className="text-foreground font-medium">{t('hint.title')}</p>
        <ol className="text-muted-foreground mt-1 list-decimal space-y-0.5 pl-4">
          <li>{t('hint.step1')}</li>
          <li>{t('hint.step2')}</li>
          <li>{t('hint.step3')}</li>
        </ol>
      </div>
      <IconButton
        label={t('hint.dismiss')}
        className="h-7 w-7"
        onClick={() => {
          setHidden(true);
          writePrefs({ hintDismissed: true });
        }}
      >
        <X />
      </IconButton>
    </div>
  );
}
